<template>
  <div class="col">
    <button
      class="color"
      :class="{
        'not-available': !this.isAvailable,
        selected: isSelected,
      }"
      @click="selectColor()"
    >
      <div
        v-if="color.type === 'single'"
        class="background-full"
        :style="{ background: color.back_color }"
      ></div>
      <template v-else>
        <div
          class="background-top"
          :style="{ background: color.back_color }"
        ></div>
        <div
          class="background-bottom"
          :style="{ background: color.second_back_color }"
        ></div>
      </template>

      <div v-if="color.is_shiny" class="shiny"></div>

      <template v-if="isSelected">
        <img class="check" :src="getIcon('blue-check-circle.svg')" />
      </template>
    </button>
    <span
      class="text"
      :class="{ selected: isSelected, 'not-available': !this.isAvailable }"
    >
      {{ color.name }}
    </span>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
  name: 'ColorSelectionItem',
  props: {
    color: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState('filters', ['selectedColorIds']),
    isSelected() {
      return this.selectedColorIds.includes(this.color.id);
    },
    isAvailable() {
      return this.color.is_available === true;
    },
  },
  methods: {
    ...mapActions('filters', ['toggleSelectedColorId']),
    ...mapMutations('popup', ['openPopup']),
    ...mapActions('brand-color-selection', ['fetchMissingProductIdsFromColor']),
    selectColor() {
      if (!this.isAvailable) {
        this.fetchMissingProductIdsFromColor(this.color.id);
        this.openPopup({
          metaData: { colorId: this.color.id },
          type: 'color',
        });
        return;
      }

      this.toggleSelectedColorId(this.color.id);
    },
  },
};
</script>
